<template>
    <table cellspacing="0" cellpadding="0" border="0" :style="styleObject">
        <colgroup>
            <col v-for="(column, index) in columns" :width="setCellWidth(column)">
        </colgroup>
        <tbody :class="[prefixCls + '-tbody']">
            <template v-for="(row, index) in data">
                <table-tr
                    :draggable="draggable"
                    :row="row"
                    :key="row._rowKey"
                    :prefix-cls="prefixCls"
                    :sourceData="sourceData(row._index)"
                    @mouseenter.native.stop="handleMouseIn(row._index)"
                    @mouseleave.native.stop="handleMouseOut(row._index)"
                    @click.native="handleClick(row._index, index)"
                    @dblclick.native.stop="dblclickCurrentRow(row._index)">
                    <table-cell v-if="!isMerge(index, colIndex)" v-for="(column, colIndex) in columns" 
                        :rowspan="rowspan(index, colIndex)"
                        :colspan="colspan(index, colIndex)"
                        :fixed="fixed"
                        :prefix-cls="prefixCls"
                        :row="row"
                        :key="column._columnKey"
                        :column="column"
                        :column-width="setCellWidth(column)"
                        :natural-index="index"
                        :index="row._index"
                        :rowState="objData[row._index]"
                        :source-data="sourceData(row._index)"
                        :validation="cellValidation(row._index, column.key)">
                    </table-cell>
                </table-tr>
                <tr v-if="objData[row._index]._isExpanded" :class="{[prefixCls + '-expanded-hidden']: fixed}">
                    <td :colspan="columns.length" :class="prefixCls + '-expanded-cell'">
                        <Expand :key="row._rowKey" :row="row" :render="expandRender" :index="row._index"></Expand>
                    </td>
                </tr>
            </template>
        </tbody>
    </table>
</template>
<script>
    // todo :key="row"
    import TableTr from './table-tr.vue';
    import TableCell from './cell.vue';
    import Expand from './expand.js';
    import Mixin from './mixin';

    let mergeArea = {}
    
    export default {
        name: 'TableBody',
        mixins: [ Mixin ],
        components: { TableCell, Expand, TableTr },

        inject: ['tableRoot'],

        props: {
            prefixCls: String,
            styleObject: Object,
            columns: Array,
            data: Array,    // rebuildData
            objData: Object,
            columnsWidth: Object,
            fixed: {
                type: [Boolean, String],
                default: false
            },
            draggable: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            expandRender () {
                let render = function () {
                    return '';
                };
                for (let i = 0; i < this.columns.length; i++) {
                    const column = this.columns[i];
                    if (column.type && column.type === 'expand') {
                        if (column.render) render = column.render;
                    }
                }
                return render;
            },
        },
        methods: {
            rowChecked (_index) {
                return this.objData[_index] && this.objData[_index]._isChecked;
            },
            rowDisabled(_index){
                return this.objData[_index] && this.objData[_index]._isDisabled;
            },
            rowExpanded(_index){
                return this.objData[_index] && this.objData[_index]._isExpanded;
            },
            rowEditing(_index){
                return this.objData[_index] && this.objData[_index]._isEditing;
            },
            handleMouseIn (_index) {
                this.$parent.handleMouseIn(_index);
            },
            handleMouseOut (_index) {
                this.$parent.handleMouseOut(_index);
            },
            handleClick(_index, index){
                this.clickCurrentRow(_index)
                this.clickNaturalRow(_index, index)
            },
            clickCurrentRow (_index) {
                this.$parent.clickCurrentRow(_index);
            },
            clickNaturalRow(_index, index){
                this.$parent.clickNaturalRow(_index, index);
            },
            dblclickCurrentRow (_index) {
                this.$parent.dblclickCurrentRow(_index);
            },
            // 跨列
            colspan(rowIndex, colIndex){
                var row = this.data[rowIndex],
                    key = this.columns[colIndex].key

                var merge = row && row._merge ? row._merge[key] : null
                
                if(merge){
                    var { rowspan: rs = 1, colspan: cs = 1 } = merge
                    // 添加合并单元格
                    for(var i = rowIndex; i < rs + rowIndex; i++){
                        for(var j = colIndex; j < cs + colIndex; j++){
                            mergeArea[i] = mergeArea[i] || {}
                            mergeArea[i][j] = true    
                        }
                    }

                    // 排除自己
                    mergeArea[rowIndex][colIndex] = false

                    return cs
                }

                return 1
            },
            // 跨行
            rowspan(rowIndex, colIndex){
                var row = this.data[rowIndex],
                    key = this.columns[colIndex].key

                var merge = row && row._merge ? row._merge[key] : null

                if(merge){
                    return merge.rowspan || 1
                }

                return 1
            },
            // 是否被合并
            isMerge(x, y){
                // 如果是第一个单元格，清空mergeArea
                if(x == 0 && y == 0){
                    mergeArea = {}

                    return false
                }

                return mergeArea[x] && mergeArea[x][y]
            },
            // 获取原数据
            sourceData(_index){
                return this.tableRoot.data[_index]
            },
            cellValidation(_index, key){
                return this.tableRoot.validations.find(d => d.index == _index && d.key == key)
            },
        }
    };
</script>
